module.exports = __webpack_public_path__ + "img/advertising.a2baa69c.png";